Core.GroupRouter = Core.SubRouter.extend({
    routes: {
        'csat':'groupSettingsCsat',
        'sms':'groupSettingsCsat',
        '': 'groupDetails',
        ':id': 'viewGroup',
        'new': 'newGroup',
    },

    groupDetails: function () {
        debug.log('groupdetails');
        app.setMainView(new GroupDetailsView(), 'directory');
    },

    viewGroup: function (id) {
        debug.log('view group id:', id);
        var view = new GroupDetailsView({id: id});
        app.setMainView(view, 'directory');
    },

    newGroup: function () {
        debug.log('new group');
        var view = new GroupDetailsView({model: new Core.Group()});
        app.setMainView(view, 'directory');
    },

    groupSettingsCsat: function(){
        var view = new GroupDetailsView({scroll: {
            tab: "tab-settings",
            element: "#sms-options",
        }});
        app.setMainView(view, 'directory');
    }
});
